import { useContext } from 'react';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import { USER_GROUP_TYPES, UserContext } from '@namespace/user';

import styles from './index.module.css';

const ChatButton = () => {
  const [user] = useContext(UserContext);
  const { role: userRole } = user;
  const isGuest = userRole === USER_GROUP_TYPES.GUEST;
  return (
    <Box
      onClick={window.ShowSupport}
      className={isGuest ? styles.guestChatButton : styles.chatButton}
    >
      <Icon name="icons/user_menu/support_ro" className={styles.chatIcon} />
    </Box>
  );
};

export default ChatButton;
